import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGrayLight1 } from 'styles/layout/colors';
const IconMobileGrid1x = t0 => {
  const $ = _c(8);
  let otherProps;
  let t1;
  if ($[0] !== t0) {
    ({
      color: t1,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
  } else {
    otherProps = $[1];
    t1 = $[2];
  }
  const color = t1 === undefined ? colorGrayLight1 : t1;
  let t2;
  if ($[3] !== color) {
    t2 = <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g transform="translate(-338.000000, -165.000000)"><g transform="translate(338.000000, 165.000000)"><path d="M0.75,23.75 L21.25,23.75 L21.25,4.75 L0.75,4.75 L0.75,23.75 Z" stroke={color} strokeWidth="1.5" /><polygon fill={color} points="0 1.5 22 1.5 22 0 0 0" /><polygon fill={color} points="0 28.5 22 28.5 22 27 0 27" /></g></g></g>;
    $[3] = color;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== otherProps || $[6] !== t2) {
    t3 = <svg width="22px" height="29px" viewBox="0 0 22 29" {...otherProps}>{t2}</svg>;
    $[5] = otherProps;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
IconMobileGrid1x.propTypes = {
  color: PropTypes.string
};
export default IconMobileGrid1x;